import type React from 'react';

import * as styles from './styles';
import { cn } from '@cobliteam/ui/utils';
import { Typography } from '@material-ui/core';

import Icon, { type IconNames } from '@cobliteam/ui/icons';

export interface TagProps {
  className?: string;
  iconName?: IconNames;
  label?: string | JSX.Element;
  labelComplement?: string | JSX.Element;
}

export const Tag: React.FC<TagProps> = ({ className = '', iconName, label, labelComplement }) => (
  <div className={cn(styles.tag, className)}>
    {iconName && <Icon name={iconName} className={styles.icon} />}
    {label && (
      <>
        <Typography variant='inherit' noWrap>
          {label}
        </Typography>
        {labelComplement}
      </>
    )}
  </div>
);
